/* eslint-disable no-undef */
export class BDGoogleMap {
  constructor (dom, apiKey, geocodeKey, config) {
    this.dom = dom
    this.config = config
    this.apiKey = apiKey
    this.geocodeKey = geocodeKey
    this.map = null
    this.polygon = null
    this.dragMarker = null

    this.revertToPoint = null
  }

  initialize () {
    return new Promise((resolve, reject) => {
      this.map = new google.maps.Map(this.dom, this.mapConfiguration())
      this.center(this.config.mapDefaultCenterLocation)
      resolve()
    })
  }

  center (point) {
    if (this.revertToPoint == null) {
      this.revertToPoint = point
    }

    this.map.setCenter(point)
  }

  resetCenter () {
    this.map.setCenter(this.revertToPoint)
  }

  centerOnAddress (address) {
    return new Promise((resolve, reject) => {
      const addressParam = address.split(' ').join('+')
      const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressParam + '&key=' + this.geocodeKey
      fetch(url, { method: 'get' })
        .then(response => response.json())
        .then(response => ({
          lat: response.results[0].geometry.location.lat,
          lng: response.results[0].geometry.location.lng
        }))
        .then(mapCenter => {
          this.revertToPoint = mapCenter
          this.center(mapCenter)
          resolve()
        })
    })
  }

  drawPolygon (points) {
    if (this.polygon) {
      this.polygon.setPaths(points)
    } else {
      this.polygon = new google.maps.Polygon({
        paths: points,
        ...this.polygonConfiguration(),
        ...this.config.polygonConfiguration
      })
      this.polygon.setMap(this.map)
    }
  }

  drawDragMarker (point) {
    if (point == null) {
      this.dragMarker.setMap(null)
    }

    if (this.dragMarker) {
      this.dragMarker.setPosition(point)
      this.dragMarker.setMap(this.map)
    } else {
      const markerIcon = new google.maps.MarkerImage(this.config.dragHandle.src,
        new google.maps.Size(this.config.dragHandle.width, this.config.dragHandle.height),
        new google.maps.Point(0, 0),
        new google.maps.Point(this.config.dragHandle.width / 2, this.config.dragHandle.height / 2))

      this.dragMarker = new google.maps.Marker({
        position: point,
        map: this.map,
        draggable: false,
        icon: markerIcon
      })
    }
  }

  mapConfiguration () {
    return {
      zoom: 20,
      tilt: 0,
      zoomControl: true,
      scaleControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      draggable: true,
      rotateControlOptions: true,
      rotateControl: true,
      mapTypeId: 'satellite',
      minZoom: 19,
      gestureHandling: 'greedy',
      mapTypeControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_RIGHT,
        mapTypeIds: ['roadmap', 'satellite']
      },
      ...this.config.mapConfiguration
    }
  }

  polygonConfiguration () {
    return {
      strokeColor: '#FFFFFF',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#1F7D95',
      fillOpacity: 1,
      draggable: true
    }
  }
}
